import { SourcingService } from 'api-clients/monolith';

import { QueryParams } from '@/hooks/use-filter-query';

export function getPositions(params: QueryParams) {
  return SourcingService.getInternalApiSourcingPositions(
    params.page,
    params.perPage,
    params.sortBy,
    params.sortDirection,
    params.query,
    params.isSelectedForSourcing,
  );
}
